<div class="bw-dialog info-dialog">

  <lib-page-header screenName="Legal" title="Terms of Service">
    <mat-icon icon>gavel</mat-icon>
    <ng-container subtitle>
      <span>The agreement governing your use of BookWise</span>
    </ng-container>
  </lib-page-header>

  <div class="bw-body">
    <p class="intro">
      These Terms of Service govern your use of BookWise. By using our services, you agree to these terms. Please read them carefully.
    </p>

    <h3>1. Acceptance of Terms</h3>
    <p>By accessing or using BookWise, you agree to comply with these terms. If you do not agree, you may not use our services.</p>

    <h3>2. User Responsibilities</h3>
    <p>As a user of BookWise, you agree to:</p>
    <ul>
      <li>Provide accurate and up-to-date information during registration.</li>
      <li>Maintain the confidentiality of your account credentials.</li>
      <li>Use BookWise in compliance with applicable laws and regulations.</li>
      <li>Refrain from engaging in prohibited activities, such as spamming, hacking, or distributing harmful content.</li>
    </ul>

    <h3>3. Prohibited Activities</h3>
    <p>You may not use BookWise for:</p>
    <ul>
      <li>Illegal or unauthorized activities.</li>
      <li>Infringing on intellectual property rights.</li>
      <li>Interfering with or disrupting our services.</li>
    </ul>

    <h3>4. Termination</h3>
    <p>BookWise reserves the right to suspend or terminate your account if you violate these terms or engage in harmful activities.</p>

    <h3>5. Limitation of Liability</h3>
    <p>BookWise is provided on an "as is" basis. We are not liable for damages arising from your use of the service, including but not limited to data loss, service interruptions, or unauthorized access.</p>

    <h3>6. Modifications to the Terms</h3>
    <p>BookWise may update these terms from time to time. Continued use of the service after changes are made constitutes your acceptance of the updated terms.</p>

    <h3>7. Governing Law</h3>
    <p>These terms are governed by and construed in accordance with the laws of Canada, without regard to its conflict of laws principles.</p>
  </div>


</div>
